import { gql } from '@apollo/client'
import { Fragments } from '../../../../web/src/graphql/fragments'

/**
 * Fetches a thread to be displayed in the inbox
 */
export const fetchThreadQuery = gql`
  query FetchThread($threadId: Int!, $loadOptions: MessageLoadOptionsInput!) {
    thread(threadId: $threadId, updateLastRead: true) {
      id
      timeCreated
      messageType
      conversationType
      isArchived
      archiveUntil
      addressUs
      addressThem
      botStatus
      preferredTourType
      unitTypesInterested
      moveInDate
      additionalOccupants
      leasingAttributionSource
      contactThem {
        ...Contact
        customAgentNamePhone
        preferMessageType
      }
      botThread {
        ...BotThread
      }
      recentActions(limit: 100) {
        id
        timeCreated
        actionName
        actionDisplayName
        user {
          id
          name
        }
        summary
        validationErrors {
          validationType
          errorDescription
          canBeRerunInCC
        }
      }
      messagesWithLinks(loadOptions: $loadOptions) {
        ...MessagesWithLinks
      }
      calendar {
        id
        timeLastAccess
      }
      transcriptUrl
      isTyping
      isUnsubscribed
      isAgentSteppedIn
    }
  }
  ${Fragments.contact}
  ${Fragments.botThread}
  ${Fragments.message}
  ${Fragments.actionToExec}
  ${Fragments.messagesWithLinks}
`
